import { render, staticRenderFns } from "./EditorText.vue?vue&type=template&id=16cd0656&scoped=true&"
import script from "./EditorText.vue?vue&type=script&lang=js&"
export * from "./EditorText.vue?vue&type=script&lang=js&"
import style0 from "./EditorText.vue?vue&type=style&index=0&id=16cd0656&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cd0656",
  null
  
)

export default component.exports